import { gql } from '@apollo/client';

export const GET_PRODUCTION_PLAN_QUERY = gql`
  query GetProductionPlan($kitchen: String!, $from: AWSDateTime!, $to: AWSDateTime!) {
    getProductionPlan(kitchen: $kitchen, from: $from, to: $to) {
      kitchen
      runId
      publishedAt
      summary
      timeZone
      sections {
        id
        title
      }
      tasks {
        id
        title
        assigneeId
        assigneeName
        startsAt
        endsAt
        doneAt
        detail {
          taskId
          type
          locationId
          itemType
          itemId
          itemName
          quantity
          unit
          readyBy
          rationale
        }
      }
      gaps {
        readyBy
        itemType
        itemId
        itemName
        kind
        lateMinutes
      }
    }
  }
`;

export const GET_PRODUCTION_PLAN_HEADER_QUERY = gql`
  query GetProductionPlanHeader($kitchen: String!, $from: AWSDateTime!, $to: AWSDateTime!) {
    getProductionPlan(kitchen: $kitchen, from: $from, to: $to) {
      runId
      publishedAt
      summary
      gaps {
        kind
        lateMinutes
      }
    }
  }
`;

export const ON_PRODUCTION_PLAN_UPDATED_SUBSCRIPTION = gql`
  subscription OnProductionPlanUpdated($kitchen: String!) {
    onProductionPlanUpdated(kitchen: $kitchen) {
      kitchen
      runId
    }
  }
`;

export const RUN_PLANNER_NOW_MUTATION = gql`
  mutation RunPlannerNow($kitchen: String!) {
    runPlannerNow(kitchen: $kitchen) {
      started
      reason
    }
  }
`;
